import { useEffect } from 'react'
import { useRouterState } from '@tanstack/react-router'

import { initGa4, trackGa4PageView } from './ga4'
import { initYandexMetrica, trackYandexMetricaPageView } from './yandex-metrica'

let lastTrackedPageViewKey: string | null = null

export const useAnalyticsPageView = (): void => {
  const location = useRouterState({
    select: (state) => state.location,
  })

  useEffect(() => {
    const pageLocation = new URL(location.publicHref, window.location.origin)
      .href

    if (lastTrackedPageViewKey === pageLocation) {
      return
    }

    lastTrackedPageViewKey = pageLocation

    initGa4()
    const didInitYandexMetrica = initYandexMetrica()
    trackGa4PageView(pageLocation, document.title)

    if (!didInitYandexMetrica) {
      trackYandexMetricaPageView(pageLocation)
    }
  }, [location.pathname, location.searchStr, location.hash])
}
